<template>
  <div ref="form">
    <PhoneStepDetailPassword
      v-show="loginType === 'password'"
      @changeLoginType="changeLoginType"
      ref="detail"
    />
    <PhoneStepDetailVerificationCode
      v-show="loginType === 'verificationCode'"
      @changeLoginType="changeLoginType"
      ref="detail"
    />
  </div>
</template>

<script>
import PhoneStepDetailPassword from './PhoneStepDetailPassword'
import PhoneStepDetailVerificationCode from './PhoneStepDetailVerificationCode'

export default {
  name: '',
  props: {},
  components: { PhoneStepDetailPassword, PhoneStepDetailVerificationCode },
  data() {
    return {
      loginType: 'verificationCode',
    }
  },
  mounted() {},
  methods: {
    changeLoginType(val) {
      this.loginType = val
    },
    back() {
      this.$refs['detail'].back()
    },
  },
}
</script>
<style lang="scss" scoped></style>
